export default __webpack_public_path__ + "static/media/itemB.4f338918.gif";